module.exports = __webpack_public_path__ + "static/media/carencias.9616adfc.jpg";